import $ from 'jquery';

const LanguagePicker = (el) => {
    const $el = $(el);

    $el.on('change', function (e) {
        e.preventDefault();
        window.location = e.target.value;
    });
};

export default LanguagePicker;
